import { ActionType } from 'interfaces/generic';
import { LoadingActionTypes } from 'store/action-types/loadings';

export const setRegionDataLoading = (loading: boolean): ActionType => {
  return {
    type: LoadingActionTypes.SET_REGION_DATA_LOADING,
    payload: loading
  };
};
